<template>
    <div>
        <div class="invoices">
                На вашем счету: {{user.credit}} тенге
                <btn t="s" l="Пополнить счет" i="usd" @press='fillUp'/>
            <hr class='thin'>
        	<div class="invoice" v-for='invoice in invoices'>
        		Счет на оплату <b>№{{invoice.no}}</b> от <b>{{invoice.date}}</b><br>
        		{{invoice.description}} <br>
        		<b>Итого: {{invoice.sum}} тенге</b>
        		<div class="pull-right">
        			<btn v-if='!invoice.payd' t="s" l="Оплатить" i='usd' @press="pay(invoice._id)"/>
        			<div style="color:green" v-if='invoice.payd'><icon name='check'/> Оплачен</div>
        		</div>
        	</div>
        </div>
        <modal name="pay-modal" :isOpen="true" :width="300" :height='280'>
            <span slot='title'>Пополнение счета</span>
            <div style='padding:8px'>
                <h3>Метод оплаты: Visa/Mastercard</h3>
                <h4>Введите сумму для пополнения</h4>
                <inputi v-model="fillUpSum" label="Сумма" type='number'/>
            </div>
            <btn slot='footer' s='m' l='Пополнить' t='s' @press="createInvoice"/>
        	<!-- Выберите метод оплаты
			
        	VISA/MASTERCARD
        	QIWI
        	Счет на оплату (ЮР лица) -->
        </modal>
    </div>
</template>

<script>
    export default {
  		name: 'payments',
  		methods:{
            fillUp(){
              this.$store.commit('modalOpen','pay-modal');  
            },
  			pay(invoiceId){
                window.open('#','pay-window');
                this.$http.post('payments/pay',{invoiceId}).then((res)=>{
                    window.open(res.body.url,'pay-window');
                });
  				//this.$store.commit('modalOpen','pay-modal');
  			},
            createInvoice(){
                window.open('#','pay-window');
                this.$http.post('payments/create',{
                    sum:parseInt(this.fillUpSum), 
                    //description:`Пополнение счета на сумму ${this.fillUpSum} тенге`
                    description:`${this.fillUpSum}tenge`
                }).then((res)=>{
                    this.pay(res.body.invoice._id);
                })
            }
  		},
        data(){
        	return {
                fillUpSum:4000
        	}
        },
        mounted(){
            this.$store.dispatch('fetchInvoices');
        },
        computed:{
            user() {
                return this.$store.state.profile.user;
            },
            invoices(){
                return this.$store.state.payments.invoices;
            }
        }
    }
</script>

<style scoped>
	.invoices{
		padding:10px;
	}

	.invoice{
		border:1px solid lightgrey;
		padding:10px;
		margin-bottom:10px;
		border-radius: 4px;
	}

    table td{
        border:1px solid lightgrey;
        padding:6px;
    }
    hr{
        margin:8px;
    }
</style>